import React, {useState, useContext, useEffect} from 'react';
import {Button, Col, Form, Input, Modal, Row, Select} from 'antd';
import Colors from "../../../styles/Colors";
import {BiCheck, BiX} from "react-icons/bi";
import {PostUsuari} from "../../../dao/root/PostUsuari";
import {User} from "../../../model/root/User";
import {AuthContext} from "../../../config/AuthContext";
import {GetEmpresas} from '../../../dao/admin/GetEmpresas';
import Empresa from '../../../model/admin/Empresa';
import { PutUsuariIdPerfil } from "../../../dao/root/PutUsuariIdPerfil";

const { Option } = Select;
interface IngredientModalProps {
    visible: boolean;
    onClose: (value: boolean) => void;
    editar?: boolean;
}

const NouUsuariModal: React.FC<IngredientModalProps> = ({ visible, onClose, editar}) => {
    const [form] = Form.useForm();
    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const [empresas, setDadesEmpresa] = useState<any[]>([]);

    useEffect(() => {
        if (visible) {
            checkDades();
        }
    }, [visible]);
    async function checkDades() {
        // Obtener empresas
        try {
            const dadesEmpresas = await GetEmpresas(1, page); // TO-DO: Cambiar por id_parent
            setDadesEmpresa(dadesEmpresas || []);
        } catch (error) {
            console.error("Error:", error);
            setDadesEmpresa([])
        }
    }

    async function handleSubmit() {  
        const empresaSeleccionada = form.getFieldValue('empresa');
        const formData = form.getFieldsValue();
        const status = await PutUsuariIdPerfil("0", empresaSeleccionada , formData);
       
        onClose(true);
    };

    async function handleCancel() {
        onClose(false); 
    };

    return (
        <Modal
            title="Crear Usuari"
            open={visible}
            onCancel={handleCancel}
            width={'50%'}
            footer={[
            ]}
        >
            <Form form={form} onFinish={handleSubmit} >
                <br/>
                    <Form.Item 
                        label="Empresa" 
                        name="empresa" 
                        rules={[{ required: true, message: 'Introdueix l\'empresa' }]}
                    >
                        <Select
                            disabled={!editar}
                            placeholder="Selecciona una empresa"
                        >
                            {Array.isArray(empresas) && empresas.map(value =>
                                <Option key={value.id} value={value.datasource}>
                                    {value.nomEmpresa}
                                </Option>
                            )}
                        </Select>      
                    </Form.Item>
                    
                    <Row  gutter={[16, 16]}>
                        <Col span={12}>
                            <Form.Item name="nombre" label="Nom"
                                rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                <Input/> 
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="cognoms" label="Cognoms"
                                rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                <Input/>
                            </Form.Item>
                        </Col>    
                    </Row>
                                <Form.Item name="dni" label="DNI" rules={[{ required: true }]}>
                                    <Input />
                                </Form.Item>
                                <Form.Item name="correu" label="Correu Electrònic" rules={[{ required: true }]}>
                                    <Input />
                                </Form.Item>
                <hr/>
                <Row gutter={[16, 16]}>
                    <Col span={1}>
                        <Form.Item wrapperCol={{offset: 0, span: 16}}>
                            <Button title={"Aceptar"} htmlType={"submit"}
                                    style={{backgroundColor: Colors.colors.color6}}><BiCheck/></Button>
                        </Form.Item>
                    </Col>
                    <Col span={1}>
                    </Col>
                    <Col span={1}>
                        <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                                onClick={handleCancel}><BiX/></Button>
                    </Col>
                </Row>
            
            </Form>
        </Modal>
    );
};

export default NouUsuariModal;
